module.exports = __webpack_public_path__ + "static/media/schenken_land.d9ffbdd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/schenken_land.svg
// module id = 287
// module chunks = 0